export function searchFilterPanel() {
    if (document.getElementById("apartment-search-filters") !== null) {
        const searchFilterModal = document.getElementById("apartment-search-filters");
        const toggleFiltersButtons = document.querySelectorAll(".toggle-filters");
        const body = document.querySelectorAll("body");

        toggleFiltersButtons.forEach((button) => {
                button.addEventListener('click', function (event) {
                        event.preventDefault()
                        searchFilterModal.classList.toggle('open');
                        body[0].classList.toggle('no-scroll',);
                        body[0].classList.toggle('panel-overlay',);
                        searchFilterModal.querySelectorAll(".close-modal")[0].focus();
                    }
                )
            }
        )

        // Closes filters when clicking outside panel.
        body[0].addEventListener('click', function (event) {
                if (event.target.classList.contains('panel-overlay')) {
                    searchFilterModal.classList.toggle('open');
                    body[0].classList.toggle('no-scroll',);
                    body[0].classList.toggle('panel-overlay',);
                }
            }
        )
    }
}
